// Constants
import { RELOADED_ANIMATIONS, RELOADED_VARIANTS } from '@kubit/web-ui-product-components';
const DEFAULT_LOADER_PROPS = {
    size: RELOADED_VARIANTS.LoaderSizesType.SMALL,
    animation: RELOADED_ANIMATIONS.animation_loader_bubble,
};
export { DEFAULT_LOADER_PROPS };
//# sourceMappingURL=button.configurations.constants.js.map